import React from 'react';
import Container from 'muicss/lib/react/container';
import Row from 'muicss/lib/react/row';
import Col from 'muicss/lib/react/col';
import Panel from 'muicss/lib/react/panel';
import Tabs from 'muicss/lib/react/tabs';
import Tab from 'muicss/lib/react/tab';
import NewTrustline from './NewTrustline';
import ReceivingTestSetup from './ReceivingTestSetup';
import SendingTestSetup from './SendingTestSetup';
import TestStatus from './TestStatus';
import TestLog from './TestLog'
import axios from 'axios';
import querystring from 'querystring';
import _ from 'lodash';

export default class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {initializing: false, inTest: false};
  }

  onStartTest(params) {
    this.setState({initializing: true});
    let urlValues = querystring.stringify(_.pick(params, ["scenario", "address", "asset_code", "asset_issuer", "amount"]));
    axios.post(`${process.env.HOST}/tests`, urlValues)
      .then(response => {
        this.setState({scenario: params.scenario, id: response.data.id, inTest: true});
        this.startCheckingStatus();
      })
      .catch(response => {
        console.error(response);
        this.setState({initializing: false});
      });
  }

  startCheckingStatus() {
    if (!this.state.id) {
      return;
    }

    axios.get(`${process.env.HOST}/tests?id=${this.state.id}`)
      .then(response => {
        this.setState({status: response.data});
        if (!response.data.finished) {
          this.timerID = setTimeout(this.startCheckingStatus.bind(this), 2000);
        }
      });
  }

  stopCheckingStatus() {
    clearTimeout(this.timerID);
  }

  onCancelTest() {
    axios.delete(`${process.env.HOST}/tests?id=${this.state.id}`);
    this.stopCheckingStatus();
    this.setState({scenario: null, id: null, initializing: false, inTest: false});
  }

  render() {
    return <Container fluid={true}>
      <Row>
        <Col className="sending-setup" md="6" md-offset={!this.state.inTest ? '3' : ''}>
          <Panel>
            <Tabs onChange={this.onChange}>
              <Tab value="sending-pane" label="Sending">
                <SendingTestSetup
                  id={this.state.id}
                  initializing={this.state.initializing}
                  onStartTest={this.onStartTest.bind(this)}
                  onCancelTest={this.onCancelTest.bind(this)} />
              </Tab>
              <Tab value="receiving-pane" label="Receiving">
                <ReceivingTestSetup
                  id={this.state.id}
                  initializing={this.state.initializing}
                  onStartTest={this.onStartTest.bind(this)}
                  onCancelTest={this.onCancelTest.bind(this)} />
              </Tab>
              <Tab value="trusline-pane" label="New Trustline">
                <NewTrustline />
              </Tab>
            </Tabs>
          </Panel>
        </Col>
        <Col className={this.state.inTest ? 'sending-right' : 'sending-setup hide'} md="6">
          <TestStatus {...this.state.status} />
          <TestLog id={this.state.id} {...this.state.status} />
        </Col>
      </Row>
    </Container>
  }
}



// WEBPACK FOOTER //
// ./src/components/Main.js